import { render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Router, { route } from 'preact-router';
import LoginView from './views/Login.jsx';
import DashboardView from './views/Dashboard.jsx';
import './app.css';

function App() {
  const [auth, setAuth] = useState({ loading: true, userId: null });

  useEffect(() => {
    fetch('/api/auth/me', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        setAuth({ loading: false, userId: data?.userId || null, displayName: data?.displayName });
        const path = window.location.pathname;
        if (data?.userId && path === '/login') route('/dashboard', true);
        if (!data?.userId && path !== '/login') route('/login', true);
      })
      .catch(() => setAuth({ loading: false, userId: null }));
  }, []);

  if (auth.loading) {
    return <div class="center-screen">Laden…</div>;
  }

  return (
    <Router>
      <LoginView path="/login" onLoggedIn={u => setAuth({ loading: false, ...u })} />
      <DashboardView path="/dashboard" auth={auth} onLogout={() => setAuth({ loading: false, userId: null })} />
      <DashboardView path="/" auth={auth} onLogout={() => setAuth({ loading: false, userId: null })} default />
    </Router>
  );
}

render(<App />, document.getElementById('app'));
